import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Hero from "./components/custom/Hero";
import Features from "./components/custom/Features";
import Logos from "./components/custom/Logos";
import Scenarios from "./components/custom/Scenarios";
import IntroduceAPI from "./components/custom/IntroduceAPI";
import Pricing from "./components/custom/Pricing";
import Functions from "./components/custom/Functions";
import Contact from "./components/custom/Contact";
import Footer from "./components/custom/Footer";
import LineBtn from "./components/custom/LineBtn";
import AnimationRevealPage from "helpers/AnimationRevealPage";

const MainPage = () => {
  let history = useHistory();
  useEffect(() => {
    const element = document.getElementById(history.location.hash);
    if (element) element.scrollIntoView({ behavior: "smooth" });

    return history.listen((location, action) => {
      const element = document.getElementById(location.hash);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    });
  }, [history]);

  useEffect(() => {
    const element = document.getElementById(history.location.hash);

    // wait for style loading finished
    let timer = setTimeout(() => {
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [history]);

  return (
    <AnimationRevealPage disabled>
      <Hero />
      <Features />
      <Logos />
      <Functions />
      <Scenarios />
      <IntroduceAPI />
      <Pricing />
      <Contact />
      <Footer />
      <LineBtn />
    </AnimationRevealPage>
  );
};

export default MainPage;
